import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import { AuthCodeFlow } from "./AuthCodeFlow";
import { getAuthClaimsEntity } from "src/app/utils";
import AuthContext from "src/app/contexts/auth-context";
import Loader from "src/app/pages/common/loader/loader";

const AuthCallback: React.FC = () => {
  const location = useLocation();

  const authCodeExchanged = useRef<boolean>(false);
  const authContext = useContext(AuthContext);

  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code") ?? "";
  const state = queryParams.get("state") ?? "";
  const error = queryParams.get("error") ?? "";

  const getAuthorizationClaims = useCallback(async () => {
    const authFlow = new AuthCodeFlow();

    try {
      const response = await authFlow.exchangeAuthorizationCode(
        code,
        state,
        error
      );
      const decodedToken = getAuthClaimsEntity(response.access_token);
      localStorage.setItem("token", response.access_token);
      localStorage.setItem("refresh_token", response.refresh_token);
      localStorage.setItem("id_token", response.id_token);

      authContext.getLoggedInUser?.(decodedToken?.email as string);
    } catch (error) {
      console.error(error);
    }
  }, [code, error, state, authContext]);

  useEffect(() => {
    if (authCodeExchanged.current) {
     
      return;
    }
   

    if (code) {
      getAuthorizationClaims();
      authCodeExchanged.current = true;

     
    }
  }, [location, code, getAuthorizationClaims]);

  return (
    <div>
      <Loader loaderSize={20} />
    </div>
  );
};

export default AuthCallback;
